import { Link } from 'react-router-dom';

const illustration = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='200' height='200' viewBox='0 0 200 200' fill='none'%3E%3Ccircle cx='100' cy='100' r='90' fill='%23f3e8ff'/%3E%3Ctext x='100' y='115' text-anchor='middle' font-family='Clash Display,sans-serif' font-size='72' font-weight='700' fill='%233e0f9e'%3E404%3C/text%3E%3C/svg%3E";

export default function NotFoundPage() {
  return (
    <section style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      minHeight: '70vh', textAlign: 'center', padding: '60px 24px',
    }}>
      <img src={illustration} alt="404" style={{ width: 180, height: 180, marginBottom: 24 }} />
      <h1 style={{
        fontFamily: "'Clash Display', sans-serif", fontSize: 40, fontWeight: 700,
        color: 'var(--color-primary-dark)', marginBottom: 12,
      }}>
        Página no encontrada
      </h1>
      <p style={{
        fontSize: 16, color: 'var(--color-text-muted)', maxWidth: 420, lineHeight: 1.6, marginBottom: 32,
      }}>
        Lo sentimos, la página que buscas no existe o fue movida. Regresa al inicio para explorar los mejores eventos en Colombia.
      </p>
      <Link to="/" className="boton-principal" style={{ padding: '14px 36px', fontSize: 15 }}>
        Volver al Inicio
      </Link>
    </section>
  );
}
